/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import PropTypes from "prop-types";
import DevicesHeaderActions from "./DevicesHeaderActions";
import DevicesHeaderFiltersRecap from "./DevicesHeaderFiltersRecap";
import useCheckMobileScreen from "../../../utils/common/useCheckMobileScreen";

const DevicesHeader = ({ axis }) => {
  const bundleSelected = axis.bundle?.motorReference !== undefined && axis.bundle?.motorReference !== null;

  const isMobile = useCheckMobileScreen();

  return (
    <div
      className={`border-[1px] border-solid border-gray-200 border-l-4 bg-gray-10 cursor-pointer flex items-center drop-shadow-sm
    ${bundleSelected ? "border-l-primary" : "border-l-gray-300 hover:border-l-gray-400"}`}
    >
      <span
        title={axis.name}
        className="hidden md:block md:visible text-gray-500 pl-3 text-sm w-36 font-bold whitespace-nowrap overflow-hidden text-ellipsis"
      >
        {axis.name}
      </span>
      <DevicesHeaderFiltersRecap axis={axis} />
      {!isMobile && <DevicesHeaderActions axis={axis} />}
    </div>
  );
};

DevicesHeader.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  axis: PropTypes.any.isRequired
};

export default DevicesHeader;
